import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "@/contexts"
import { PortalRole } from "@/types"

interface ProtectedRouteProps {
  children: ReactNode
  allowedRoles?: Array<PortalRole>
}

export const ProtectedRoute = ({
  children,
  allowedRoles
}: ProtectedRouteProps) => {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(user.userType as PortalRole)
  ) {
    // optional: role-based redirect
    const redirect =
      user.userType === PortalRole.ESO_PERSON
        ? "/core/pipeline"
        : "/client/deals"

    return <Navigate to={redirect} replace />
  }

  return <>{children}</>
}